// src/Redux/Slice/partyCallSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BaseUrl = process.env.REACT_APP_API_URL;

// Fetch all call summaries
export const fetchPartyCallDetails = createAsyncThunk(
  "partyCall/fetchTaskFind",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/asrfeer34645fgdfsdsdgh5d`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Fetch specific call details by ID
export const fetchPartyCallDetailById = createAsyncThunk(
  "partyCall/fetchById",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/dfshfgjhfgjfghjsdfg/${id}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || `Failed to fetch details for ID: ${id}`
      );
    }
  }
);

// Fetch all detail categories by ID
export const fetchPartyCallDetailAllById = createAsyncThunk(
  "partyCall/fetchAllById",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/dfshfsdfgjftghjfghjgh/${id}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || `Failed to fetch details for ID: ${id}`
      );
    }
  }
);

// Fetch all detail categories by ID
export const EMPDETAILS = createAsyncThunk(
  "partyCall/Conplain_ShowInHouse_acc",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/Conplain_ShowInHouse_acc`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || `Failed to fetch details for ID: ${id}`
      );
    }
  }
);

const partyCallSlice = createSlice({
  name: "partyCall",
  initialState: {
    // List/Summary
    partyCallListLoading: false,
    partyCallListError: null,
    Partydatacard: [],

    // Single Detail
    partyCallDetailLoading: false,
    partyCallDetailError: null,
    selectedPartyCallDetail: null,

    // All Detail Types (Pending, Complete, Total, etc.)
    partyCallAllDetailLoading: false,
    partyCallAllDetailError: null,
    selectedPartyCallDetailAll: null,

    // All Detail Types (Pending, Complete, Total, etc.)
    EMPDETAILSDetailLoading: false,
    EMPDETAILSDetailError: null,
    selectedPartyEMPDETAILS: null,
  },

  reducers: {
    clearSelectedPartyCallDetail: (state) => {
      state.selectedPartyCallDetail = null;
      state.partyCallDetailLoading = false;
      state.partyCallDetailError = null;
    },
    clearSelectedPartyCallDetailAll: (state) => {
      state.selectedPartyCallDetailAll = null;
      state.partyCallAllDetailLoading = false;
      state.partyCallAllDetailError = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // === All Call Summaries ===
      .addCase(fetchPartyCallDetails.pending, (state) => {
        state.partyCallListLoading = true;
        state.partyCallListError = null;
      })
      .addCase(fetchPartyCallDetails.fulfilled, (state, action) => {
        state.partyCallListLoading = false;
        state.Partydatacard = action.payload;
      })
      .addCase(fetchPartyCallDetails.rejected, (state, action) => {
        state.partyCallListLoading = false;
        state.partyCallListError = action.payload;
        state.Partydatacard = [];
      })

      // === Single Call Detail by ID ===
      .addCase(fetchPartyCallDetailById.pending, (state) => {
        state.partyCallDetailLoading = true;
        state.partyCallDetailError = null;
        state.selectedPartyCallDetail = null;
      })
      .addCase(fetchPartyCallDetailById.fulfilled, (state, action) => {
        state.partyCallDetailLoading = false;
        state.selectedPartyCallDetail = action.payload;
      })
      .addCase(fetchPartyCallDetailById.rejected, (state, action) => {
        state.partyCallDetailLoading = false;
        state.partyCallDetailError = action.payload;
        state.selectedPartyCallDetail = null;
      })

      // === All Call Details by ID (Total, Pending, Complete, etc.) ===
      .addCase(fetchPartyCallDetailAllById.pending, (state) => {
        state.partyCallAllDetailLoading = true;
        state.partyCallAllDetailError = null;
        state.selectedPartyCallDetailAll = null;
      })
      .addCase(fetchPartyCallDetailAllById.fulfilled, (state, action) => {
        state.partyCallAllDetailLoading = false;
        state.selectedPartyCallDetailAll = action.payload;
      })
      .addCase(fetchPartyCallDetailAllById.rejected, (state, action) => {
        state.partyCallAllDetailLoading = false;
        state.partyCallAllDetailError = action.payload;
        state.selectedPartyCallDetailAll = null;
      })

      .addCase(EMPDETAILS.pending, (state) => {
        state.EMPDETAILSDetailLoading = true;
        state.EMPDETAILSDetailError = null;
        state.selectedPartyEMPDETAILS = null;
      })
      .addCase(EMPDETAILS.fulfilled, (state, action) => {
        state.EMPDETAILSDetailLoading = false;
        state.selectedPartyEMPDETAILS = action.payload;
      })
      .addCase(EMPDETAILS.rejected, (state, action) => {
        state.EMPDETAILSDetailLoading = false;
        state.EMPDETAILSDetailError = action.payload;
        state.selectedPartyEMPDETAILS = null;
      });
  },
});

export const { clearSelectedPartyCallDetail, clearSelectedPartyCallDetailAll } =
  partyCallSlice.actions;

export default partyCallSlice.reducer;
